import angular from 'angular';
import $ from 'jquery';

angular.module('app.services')

    .factory('DisplayService', ['$filter', 'FieldTransformer', function ($filter, FieldTransformer) {
        var service = {};

        service.applyTransformation = function (formField, formValue, creatives = []) {
            var displayPair = {};
            if (formField.cascading_field_name && formField.cascading_input_type) {
                formField.input_type = formField.cascading_input_type;
            }
            if (formField.lookup_type_id &&
                formField.input_type !== "readonly" &&
                formField.input_type !== "DFP" &&
                formField.input_type !== "day-parting" &&
                formField.input_type !== "dfp-frequency" &&
                formField.input_type !== "google-ads-aud-targeting" &&
                formField.input_type !== "devices" &&
                formField.input_type !== "device-capability" &&
                formField.input_type !== "dfp_ad_units" &&
                formField.input_type !== "connections" &&
                formField.input_type !== "multiselect-custom" &&
                formField.input_type !== "mobile-app" &&
                formField.input_type !== "geo-location" &&
                formField.input_type !== "ad-schedule" &&
                formField.input_type !== "facebook-ads-location" &&
                formField.input_type !== "snapchat-ads-location" &&
                formField.input_type !== "xandr-invest-location" &&
                formField.input_type !== "facebookAds-frequency-controls" &&
                formField.input_type !== "snapChat-frequency-controls" &&
                formField.input_type !== "xandrInvest-frequency-controls" &&
                formField.input_type !== "pinterestAds-frequency-controls" &&
                formField.input_type !== "custom-macro-mapping" &&
                formField.input_type !== "custom-macro-mapping-2" &&
                formField.input_type !== "seed-list-macros" &&
                formField.input_type !== "pos-matchback-details" &&
                formField.input_type !== "age-targeting" &&
                formField.input_type !== "snap-chat-age-targeting" &&
                formField.input_type !== "geo-targeting-google" &&
                formField.input_type !== "metric-select" &&
                formField.input_type !== "facebook-audience-targeting" &&
                formField.input_type !== "snap-gender" &&
                formField.input_type !== "advanced-demographics" &&
                formField.input_type !== "snap-predefined-audiences" &&
                formField.input_type !== "tritonAds-frequency-controls" &&
                formField.input_type !== "pinterest-audience-targeting" &&
                formField.input_type !== "linkedin-audience-targeting" &&
                formField.input_type !== "tritonAds-teams-controls" &&
                formField.input_type !== "yelpAds-categories" &&
                formField.input_type !== "image-upload" &&
                formField.input_type !== "tiktok-audience-targeting" &&
                formField.input_type !== "tiktok-device-targeting" &&
                formField.input_type !== "tiktok-languages-targeting" &&
                formField.input_type !== "links-and-main-cta" &&
                formField.input_type !== "facebook-audiences" &&
                formField.input_type !== "google-ad-manager-avail-units" &&
                formField.input_type !== "pinterest-geo-location" &&
                formField.input_type !== "final-approval" &&
                formField.input_type !== "triton-geo-targeting" &&
                formField.input_type !== "triton-listener-targeting" &&
                formField.input_type !== "facebook-page-id" &&
                formField.input_type !== "triton-creative-management" &&
                formField.input_type !== "linkedin-geo-targeting" &&
                formField.input_type !== "triton-time-targeting" &&
                formField.input_type !== "triton-content-targeting" &&
                formField.input_type !== "snapchat-pixel-controls" &&
                formField.input_type !== "triton-content-targeting" &&
                formField.input_type !== "pinterest-keyword" &&
                formField.input_type !== "accountability-group-label" &&
                formField.input_type !== "linkedin-campaign-objective" &&
                formField.input_type !== "tiktok-geo-targeting"
            ) {
                displayPair[formField.display_name] = lookupContentTransformation(formValue);
            } else if (formField.input_type == "multiselect-custom") {
                displayPair[formField.display_name] = lookupContentForCustomTransformation(formValue);
            } else if (formField.input_type == "geo-location" || formField.input_type == "facebook-ads-location" || formField.input_type == "snapchat-ads-location" || formField.input_type == "pinterest-geo-location" || formField.input_type == "xandr-invest-location" || formField.input_type == "geo-targeting-google" || formField.input_type == "facebook-audience-targeting" || formField.input_type == "snap-gender" || formField.input_type == "tritonAds-teams-controls" || formField.input_type == "yelpAds-categories" || formField.input_type == "image-upload" || formField.input_type == "advanced-demographics" || formField.input_type == "pinterest-audience-targeting" || formField.input_type == "linkedin-audience-targeting" || formField.input_type == "snap-predefined-audiences" || formField.input_type == "tiktok-audience-targeting" || formField.input_type == "tiktok-languages-targeting" || formField.input_type == "tiktok-device-targeting" || formField.input_type == "links-and-main-cta" || formField.input_type == "final-approval" || formField.input_type == "google-ad-manager-avail-units" || formField.input_type == "facebook-page-id" || formField.input_type == "triton-listener-targeting" || formField.input_type == "triton-geo-targeting" || formField.input_type == "triton-creative-management" || formField.input_type == "linkedin-geo-targeting" || formField.input_type == "triton-time-targeting" || formField.input_type == "triton-content-targeting" || formField.input_type == "snapchat-pixel-controls" || formField.input_type == "pinterest-keyword" || formField.input_type == "accountability-group-label" || formField.input_type == "linkedin-campaign-objective" || formField.input_type == "tiktok-geo-targeting") {
                displayPair[formField.display_name] = formValue;
            } else if (formField.input_type == "location-targeting") {
                displayPair[formField.display_name] = locationTargetingTransformation(formValue);
            } else if (formField.input_type == "location-picker" ||
                formField.input_type == "location-picker-fb" ||
                formField.input_type == "DFP" ||
                formField.input_type == "day-parting" ||
                formField.input_type == "dfp-frequency" ||
                formField.input_type == "devices" ||
                formField.input_type == "dfp_ad_units" ||
                formField.input_type == "connections" ||
                formField.input_type == "mobile-app" ||
                formField.input_type == "device-capability" ||
                formField.input_type == "ad-schedule" ||
                formField.input_type == "google-ads-aud-targeting" ||
                formField.input_type == "facebookAds-frequency-controls" ||
                formField.input_type == "snapChat-frequency-controls" ||
                formField.input_type == "xandrInvest-frequency-controls" ||
                formField.input_type == "pinterestAds-frequency-controls" ||
                formField.input_type == "custom-macro-mapping" ||
                formField.input_type == "custom-macro-mapping-2" ||
                formField.input_type == "seed-list-macros" ||
                formField.input_type == "pos-matchback-details" ||
                formField.input_type == "metric-select" ||
                formField.input_type == "content-links" ||
                formField.input_type == "facebook-audience-targeting" ||
                formField.input_type == "snap-gender" ||
                formField.input_type == "advanced-demographics" ||
                formField.input_type == "snap-predefined-audiences" ||
                formField.input_type == "tritonAds-frequency-controls" ||
                formField.input_type == "pinterest-audience-targeting" ||
                formField.input_type == "linkedin-audience-targeting" ||
                formField.input_type == "tritonAds-teams-controls" ||
                formField.input_type == "yelpAds-categories" ||
                formField.input_type == "image-upload" ||
                formField.input_type == "tiktok-audience-targeting" ||
                formField.input_type == "tiktok-device-targeting" ||
                formField.input_type == "tiktok-languages-targeting" ||
                formField.input_type == "bridge-email-test" ||
                formField.input_type == "links-and-main-cta" ||
                formField.input_type == "facebook-audiences" ||
                formField.input_type == "google-ad-manager-avail-units" ||
                formField.input_type == "final-approval" ||
                formField.input_type == "facebook-page-id" ||
                formField.input_type == "pinterest-keyword" ||
                formField.input_type == "accountability-group-label" ||
                formField.input_type == "linkedin-campaign-objective"
            ) {
                displayPair[formField.display_name] = formValue;
            } else if (formField.input_type == "multiple-mappings") {
                formValue = (formValue && (typeof formValue === 'string')) ? JSON.parse(formValue) : formValue;
                displayPair[formField.display_name] = (formValue && formValue.label) ? formValue.label : formValue;
            } else if (formField.input_type == "readonly") {
                if (_.isArray(formValue)) {
                    formValue = formValue[1];
                }
                displayPair[formField.display_name] = formValue;
            } else if (formField.input_type == "file") {
                let file_name_array = [];
                for(let i = 0; i < formValue.length; i++) {
                    file_name_array.push(formValue[i].file_name);
                }
                displayPair[formField.display_name] = file_name_array.join(', ');
            } else if (formField.input_type == "creative") {
                let tags_array = [];
                let filenames_array = [];
                try {
                    if (formValue) {
                        const fileInfo = JSON.parse(formValue);
                        if (fileInfo.thirdPartyCreatives) {
                            _.each(fileInfo.thirdPartyCreatives, function (item) {
                                tags_array.push(item.name);
                            });
                        }
                        if (fileInfo.selectedImages) {
                            _.each(fileInfo.selectedImages, function (item) {
                                filenames_array.push(item.file_name);
                            });
                        }
                    }
                } catch (e) {
                    console.log('Creative file info is not correct');
                }
                let display_name = '';
                let join_string = '';
                if (tags_array.length > 0) {
                    display_name = '3rd-party creative tags: ' + tags_array.join(', ');
                    join_string = '\n';
                }
                if (filenames_array.length > 0) {
                    display_name = display_name + join_string + 'Creative files: ' + filenames_array.join(', ');
                }
                displayPair[formField.display_name] = display_name;
            } else if (formField.input_type == "checkbox") {
                displayPair[formField.display_name] = booleanTransformation(formValue);
            } else if (formField.input_type == "custom_file" && formValue) {
                if (Array.isArray(formValue)) {
                    let file_name_array = [];
                    for(let i = 0; i < formValue.length; i++) {
                        file_name_array.push(formValue[i].file_name);
                    }
                    displayPair[formField.display_name] = file_name_array.join(', ');
                } else {
                    displayPair[formField.display_name] = formValue['file_name'];
                }
            } else {
                switch (formField.data_type) {
                    case "time":
                        displayPair[formField.display_name] = timeTransformation(formValue);
                        break;
                    case "tinyint":
                        displayPair[formField.display_name] = numberTransformation(formValue);
                        break;
                    case "currency":
                        displayPair[formField.display_name] = currencyTransformation(formValue);
                        break;
                    case "percentage":
                        displayPair[formField.display_name] = percentageTransformation(formValue);
                        break;
                    case "integer":
                        displayPair[formField.display_name] = numberTransformation(formValue);
                    break;case "hyperlink":
                        displayPair[formField.display_name] = hyperlinkTransformation(formValue);
                        break;
                    default:
                        displayPair[formField.display_name] = formValue;
                }
            }
            return displayPair;
        };

        var geoLocationTransformation = function (input) {
            var includedString = "";
            var excludedString = "";

            for (var i = 0; i < input.length; i++) {
                if (input[i].criteria == "include") {
                    includedString += input[i].full_name + "(" + input[i].type + "), ";
                } else {
                    excludedString += input[i].full_name + "(" + input[i].type + "), ";
                }
            }
            ;
            //remove the commas at the end
            includedString = includedString.substring(0, includedString.length - 2);
            excludedString = excludedString.substring(0, excludedString.length - 2);

            return "INCLUDED: " + includedString + " EXCLUDED: " + excludedString;
        };

        var locationTargetingTransformation = function (input) {
            var input = JSON.parse(input);
            var output = "";
            for (var i = 0; i < input.length; i++) {
                if (input[i].parentLocations && input[i].parentLocations.length) {
                    if (input[i].parentLocations[1]) {
                        output += input[i].name + "(" + input[i].parentLocations[0].name + "," + input[i].parentLocations[1].name + "),";
                    } else {
                        output += input[i].name + "(" + input[i].parentLocations[0].name + "),";
                    }

                } else {
                    output += input[i].name
                }

            }
            ;
            return output;
        }

        var lookupContentTransformation = function (input) {
            // Check for multi-select value
            if (Array.isArray(input[0])) {
                var valueString = "";

                for (var x = 0; x < input.length; x++) {
                    var valuePair = input[x];
                    if (x == 0) {
                        valueString = valueString.concat(valuePair[1]);
                    } else {
                        valueString = valueString.concat(", " + valuePair[1]);
                    }
                }
                return valueString;
            } else {
                return input[1];
            }
        };

        var lookupContentForCustomTransformation = function (input) {
            // Check for multi-select value
            if (Array.isArray(input[0])) {
                var valueString = "";
                _.each(input, function (valuePair, index) {
                    var valuePairVal = (valuePair.length == 1) ? String(valuePair[0]).replace("CUST_", "") : valuePair[1];
                    valueString = (index == 0) ? valueString.concat(valuePairVal) : valueString.concat(", " + valuePairVal);
                });
                return valueString;
            } else {
                return input[1];
            }
        };

        var timeTransformation = function (input) {
            var timeData = input;
            if (timeData.indexOf(":") > 0 && timeData.indexOf(":", 3) > 3) { // For full date format
                timeData = timeData.split(":");
                var initialTime = new Date();
                initialTime.setHours(timeData[0]);
                initialTime.setMinutes(parseInt(timeData[1]));
                return $filter('date')(initialTime, "hh:mm a");
            }
            return input;
        };

        var currencyTransformation = function (input) {
            return FieldTransformer.transformCurrency(input)
        };

        var numberTransformation = function (input, round = 0) {
            return FieldTransformer.transformNumber(input, round)
        };

        var percentageTransformation = function (input) {
            return input + '%';
        };


        var booleanTransformation = function (input) {
            return (input == 1) ? 'yes' : 'no';
        };

        const hyperlinkTransformation = function (input) {
            if (!input) {
                return input;
            }
            const protocol = input.indexOf('http://') > -1 ? 'http://' : 'https://'; // todo: support other protocol ?
            let url = input.replace(protocol, '');
            let original_url = '';
            const str_array = url.split(' ');
            str_array.forEach((str) => {
                if (str.indexOf('.') > -1) {
                    original_url = str;
                }
            })
            const hyperlink = '<a href="' + protocol + original_url + '" target="_blank" rel="noopener noreferrer">' + original_url + '</a>';

            return url.replace(original_url, hyperlink);
        };

        service.utcToLocalDatetime = function(date, show_timezone = false) {
            if (!date || typeof date == 'object') {
                return date;
            }
            const datetime = new Date(date + ' UTC');
            const options = {
                month: 'short', // 'short' for abbreviated month name (e.g., "Dec")
                day: '2-digit', // 'numeric' for the day of the month (e.g., "4")
                year: 'numeric', // 'numeric' for the full year (e.g., "2025")
                hour: 'numeric',  // 'numeric' for hour (e.g., "10")
                minute: 'numeric', // 'numeric' for minute (e.g., "15")
                second: 'numeric', // 'numeric' for second (e.g., "30")
                hour12: true,
            };
            if (show_timezone) {
                options.timeZoneName = 'short';
            }
            return datetime.toLocaleString(
                'en-US',
                options,
            ).replace(',', '');
        }

        service.yyyymmddToShortddyyyy = function(date, time = false) {
            if (!date || typeof date == 'object') {
                return date;
            }
            const new_date = time ? new Date(date) : new Date(date + ' 00:00:00');
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: 'numeric',  // 'numeric' for hour (e.g., "10")
                minute: 'numeric', // 'numeric' for minute (e.g., "15")
                second: 'numeric', // 'numeric' for second (e.g., "30")
                hour12: true,
            };
            return new Intl.DateTimeFormat('en-US', options).format(new_date).replace(',', '');
        }

        return service;
    }]);